export default "__VITE_ASSET__CutC$PJu__"